// Module
var code = `<terceraButton name="modifyBtn"
            text="{{.modifyBtnText}}"
            enabled="{{.enabledBtn}}"
            terceraButtonStyle="js-button-ok"
            on-btnClick="modifyBtnClick" />
                
<terceraButton name="cancelBtn"
            text="{{.cancelBtnText}}"
            terceraButtonStyle="js-button-gray25"
            on-btnClick="cancelBtnClick" />`;
// Exports
export default code;